<ng-template #blockTemplate let-blockConfig='blockConfig' let-inTab='inTab' let-index='index'>
  @switch (blockConfig.type) {
    @case ("list") {
      <dataset-list
        #listBlocks
        [datasetCode]='blockConfig.datasetCode'
        [filters]='blockFilters[index]'
        [parentDatasetRS]='datasetRS'
        [parentDatasetACS]='datasetACS'
        [conditionalShowPaginationToolbar]='true'
        [showSearchBar]='false'
        [showTitle]='!inTab'
        [elevate]='false'
        (created)='onCreatedInBlock(blockConfig)'
      ></dataset-list>
    }
    @case ("document_file") {
      <document-file-block
        [title]='!inTab && blockConfig.title'
        [record]='datasetRS.record.value'
        [documentFileKey]='blockConfig.documentFileKey'
        [imageOptions]='blockConfig.imageOptions'
        [type]='"image"'
        [uploadType]='blockConfig.uploadType'
        [uploadRoute]='blockConfig.uploadRoute'
        [getUploadDataFun]='blockConfig.getUploadData'
        (changed)='datasetRS.reload()'
      ></document-file-block>
    }
    @default {
      <div>
        <p>{{'Blocco non configurato' | translate}}: {{blockConfig.type}}</p>
      </div>
    }
  }
</ng-template>

<div class='full-form'>
  <language-select
    [selected]='appService.language.value'
    (changed)='appService.language.next($event)'
    [languageCodes]='appService.supportedLanguageCodes'
    [activeLanguageCodes]='datasetMCS.activeLanguageCodes'
  ></language-select>

  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetACS.ready.value) {
    @if (!datasetRS.record.value && !datasetACS.loading.value) {
      <p>{{'Questa traduzione non è ancora presente!' | translate}}</p>
      <button mat-stroked-button color='primary' (click)='goPrevStep()'>Inserisci prima le descrizioni in lingua</button>
    }
    @if (datasetRS.record.value && datasetRS.record.value["lang"] === appService.language.value) {
      @if (stepConfig.options.blocks.length > 1) {
        <mat-tab-group>
          @for (blockConfig of stepConfig.options.blocks; track blockConfig; let i = $index) {
            <mat-tab>
              <ng-template mat-tab-label>{{blockConfig.title}}</ng-template>
              <ng-template matTabContent>
                <ng-container
                  [ngTemplateOutlet]='blockTemplate'
                  [ngTemplateOutletContext]='{blockConfig: blockConfig, inTab: true, index: i}'
                ></ng-container>
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      }
      @if (stepConfig.options.blocks.length == 1) {
        @for (blockConfig of stepConfig.options.blocks; track blockConfig; let i = $index) {
          <ng-container
            [ngTemplateOutlet]='blockTemplate'
            [ngTemplateOutletContext]='{blockConfig: blockConfig, inTab: false, index: i}'
          ></ng-container>
        }
      }
    }
  }
</div>